import { makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) =>
  createStyles({
    text: {
      fontSize: `15px`,
    },
    date: {
      paddingTop: "15px",
      fontSize: "1px",
    },
    chip: {
      fontSize: "6px",
      backgroundColor: "white",
    },
    warning: {
      height: "auto",
      display: "flex",
      borderRadius: "10px",
      padding: `10px 10px`,
      margin: `10px 15px`,
      alignItems: "center",
      justifyContent: "center",
      color: `${theme.notificationTextColor.warning}`,
      backgroundColor: `${theme.notificationBackgroundColor.warning}`,
      border: `2px solid white`,
      cursor: "pointer",
    },
    loaderwarning: {
      color: `${theme.notificationTextColor.warning}`,
    },
    success: {
      height: "auto",
      display: "flex",
      borderRadius: "10px",
      padding: `10px 10px`,
      margin: `10px 15px`,
      alignItems: "center",
      justifyContent: "center",
      color: `${theme.notificationTextColor.success}`,
      backgroundColor: `${theme.notificationBackgroundColor.success}`,
      border: `2px solid white`,
      cursor: "pointer",
    },
    loadersuccess: {
      color: `${theme.notificationTextColor.success}`,
    },
    primary: {
      height: "auto",
      display: "flex",
      borderRadius: "10px",
      padding: `10px 10px`,
      margin: `10px 15px`,
      alignItems: "center",
      justifyContent: "center",
      color: `${theme.notificationTextColor.primary}`,
      backgroundColor: `${theme.notificationBackgroundColor.primary}`,
      border: `2px solid white`,
      cursor: "pointer",
    },
    loaderprimary: {
      color: `${theme.notificationTextColor.primary}`,
    },
    activeprimary: {
      height: "auto",
      display: "flex",
      borderRadius: "10px",
      padding: `10px 10px`,
      margin: `10px 15px`,
      alignItems: "center",
      justifyContent: "center",
      color: `${theme.notificationTextColor.primary}`,
      backgroundColor: `${theme.notificationBackgroundColor.primary}`,
      border: `2px solid ${theme.notificationTextColor.primary}`,
      cursor: "pointer",
    },
    activewarning: {
      height: "auto",
      display: "flex",
      borderRadius: "10px",
      padding: `10px 10px`,
      margin: `10px 15px`,
      alignItems: "center",
      justifyContent: "center",
      color: `${theme.notificationTextColor.warning}`,
      backgroundColor: `${theme.notificationBackgroundColor.warning}`,
      border: `2px solid ${theme.notificationTextColor.warning}`,
      cursor: "pointer",
    },
    activesuccess: {
      height: "auto",
      display: "flex",
      borderRadius: "10px",
      padding: `10px 10px`,
      margin: `10px 15px`,
      alignItems: "center",
      justifyContent: "center",
      color: `${theme.notificationTextColor.success}`,
      backgroundColor: `${theme.notificationBackgroundColor.success}`,
      border: `2px solid ${theme.notificationTextColor.success}`,
      cursor: "pointer",
    },
  })
);
